import { resetAnimationsInSubtree } from '../../interactions/utils/hide-element';
import { type ReplayPreviewModeAnimations } from './types';

/**
 * Reconcile animation runtime state when Preview Mode is enabled.
 * This allows animation-enabled elements to replay on preview re-entry.
 *
 * @param {boolean} isPreviewModeActive Whether preview mode is active.
 *
 * @returns {void}
 */
export const replayPreviewModeAnimations: ReplayPreviewModeAnimations = isPreviewModeActive => {
  if (!isPreviewModeActive) {
    return;
  }

  resetAnimationsInSubtree(document.body);

  const reinitializeAnimations = (): void => {
    if ('function' === typeof window.et_reinit_waypoint_modules) {
      window.et_reinit_waypoint_modules();
    }
  };

  // Preview mode applies UI/layout changes during transition. Delay reinit until
  // after the next paints so visibility checks in animation flow run on final DOM state.
  // Double RAF ensures we wait for: (1) current paint completion, (2) layout settle after CSS changes.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      reinitializeAnimations();
    });
  });
};
